import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledPaymentMethods = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;

  .form-loader {
    width: 100%;
    margin-top: 20px;
    text-align: center;
  }

  .existing-payment-methods {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px 0px;

    .ant-radio-group {
      display: flex;
      margin-bottom: 20px;

      .ant-radio-wrapper {
        flex: 1;
        padding: 10px;
        border: 1px solid ${Colors.border};
        border-radius: 10px;
        box-shadow: ${Colors.boxShadow};

        &.ant-radio-wrapper-checked {
          border-color: ${Colors.primary};
          background: ${Colors.backgroundPaleBlue};
        }
      }
    }
  }
`;
